(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-capture-popup"] && !Shopify.designMode) return;
  try {
    
(function() {
  var STORAGE_KEY = 'wt_email_popup_seen';
  if (localStorage.getItem(STORAGE_KEY)) return;
  var popup = document.getElementById('email-capture');
  if (!popup) return;

  function show() {
    popup.classList.add('is-active');
    popup.removeAttribute('aria-hidden');
    localStorage.setItem(STORAGE_KEY, '1');
  }

  var timer = setTimeout(show, 20000);

  function onScroll() {
    var scrollPct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    if (scrollPct >= 50) {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      show();
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  var closeBtn = document.getElementById('email-capture-close');
  var overlay = document.getElementById('email-capture-overlay');
  function dismiss() {
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    localStorage.setItem(STORAGE_KEY, '1');
  }
  if (closeBtn) closeBtn.addEventListener('click', dismiss);
  if (overlay) overlay.addEventListener('click', dismiss);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-build-your-set"] && !Shopify.designMode) return;
  try {
    
(function () {
  const COLLECTIONS = {
    print: '/collections/posters-art-prints/products.json?limit=12',
    mug: '/collections/all/products.json?product_type=Mug&limit=12',
    tote: '/collections/all/products.json?product_type=Tote+Bag&limit=12'
  };

  const TYPE_LABELS = { print: 'Art Print', mug: 'Mug', tote: 'Tote Bag' };

  function formatMoney(cents) {
    return '�' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  const state = { print: null, mug: null, tote: null };

  function updateSummary() {
    const selected = document.getElementById('wt-build-set-selected');
    const btn = document.getElementById('wt-build-set-add-btn');
    const totalEl = document.getElementById('wt-build-set-total');
    const feedback = document.getElementById('wt-build-set-feedback');

    const picks = Object.entries(state).filter(function (e) { return e[1] !== null; });

    if (!picks.length) {
      selected.innerHTML = '<p class="wt-build-set__selected-empty">Select one item from each column to build your set.</p>';
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      totalEl.textContent = '';
      return;
    }

    const total = picks.reduce(function (sum, e) { return sum + e[1].price; }, 0);
    totalEl.textContent = 'Set total: ' + formatMoney(total);

    const listHtml = picks.map(function (e) {
      return '<div class="wt-build-set__sel-row">' +
        '<span class="wt-build-set__sel-type">' + TYPE_LABELS[e[0]] + '</span>' +
        '<span class="wt-build-set__sel-title">' + e[1].title + '</span>' +
        '<span class="wt-build-set__sel-price">' + formatMoney(e[1].price) + '</span>' +
        '</div>';
    }).join('');

    selected.innerHTML = '<div class="wt-build-set__selected-items">' + listHtml + '</div>';

    const allPicked = picks.length === 3;
    btn.disabled = !allPicked;
    btn.setAttribute('aria-disabled', allPicked ? 'false' : 'true');
    feedback.textContent = '';
  }

  async function fetchProducts(type, scrollId) {
    const scroll = document.getElementById(scrollId);
    if (!scroll) return;
    const tpl = document.getElementById('wt-build-set-card-tpl');

    let url = COLLECTIONS[type];
    if (type !== 'print') {
      url = '/collections/all/products.json?limit=12';
    }

    try {
      const resp = await fetch(url);
      if (!resp.ok) throw new Error('fetch error');
      const data = await resp.json();
      let products = (data.products || []);

      if (type === 'mug') {
        products = products.filter(function (p) {
          return (p.product_type || '').toLowerCase().includes('mug');
        });
      } else if (type === 'tote') {
        products = products.filter(function (p) {
          return (p.product_type || '').toLowerCase().includes('tote');
        });
      } else {
        products = products.filter(function (p) {
          const t = (p.product_type || '').toLowerCase();
          return t.includes('art print') || t.includes('poster') || t.includes('print material');
        });
      }

      products = products.slice(0, 10);
      scroll.innerHTML = '';

      if (!products.length) {
        scroll.innerHTML = '<p style="font-size:0.8rem;color:#6b6760;">No products found.</p>';
        return;
      }

      products.forEach(function (product) {
        const variant = (product.variants || [])[0];
        if (!variant) return;
        const card = tpl.content.cloneNode(true).querySelector('.wt-build-set__card');
        card.dataset.productId = product.id;
        card.dataset.variantId = variant.id;
        card.dataset.price = variant.price;
        card.dataset.title = product.title;
        card.dataset.url = '/products/' + product.handle;
        const img = card.querySelector('.wt-build-set__card-img');
        const imgSrc = product.images && product.images[0]
          ? product.images[0].src + '&width=200&height=200&crop=center'
          : '';
        img.src = imgSrc;
        img.alt = product.title || '';
        card.querySelector('.wt-build-set__card-name').textContent = product.title || '';
        card.querySelector('.wt-build-set__card-price').textContent = formatMoney(parseInt(variant.price * 100, 10));
        card.setAttribute('aria-pressed', 'false');

        card.addEventListener('click', function () {
          scroll.querySelectorAll('.wt-build-set__card').forEach(function (c) {
            c.setAttribute('aria-pressed', 'false');
          });
          card.setAttribute('aria-pressed', 'true');
          state[type] = {
            variantId: variant.id,
            price: parseInt(variant.price * 100, 10),
            title: product.title,
            type: TYPE_LABELS[type]
          };
          updateSummary();
        });

        scroll.appendChild(card);
      });
    } catch (err) {
      scroll.innerHTML = '<p style="font-size:0.8rem;color:#6b6760;">Could not load products.</p>';
    }
  }

  async function handleAddAll() {
    const btn = document.getElementById('wt-build-set-add-btn');
    const feedback = document.getElementById('wt-build-set-feedback');
    const picks = Object.values(state).filter(Boolean);
    if (!picks.length) return;

    btn.setAttribute('aria-busy', 'true');
    feedback.textContent = '';

    try {
      const items = picks.map(function (p) {
        return { id: p.variantId, quantity: 1 };
      });
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!resp.ok) throw new Error('cart error');
      feedback.textContent = 'Your set has been added to the cart!';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () {
        window.location.href = '/cart';
      }, 800);
    } catch (err) {
      feedback.textContent = 'Something went wrong - please try again.';
      feedback.style.color = '#c0392b';
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  function init() {
    const btn = document.getElementById('wt-build-set-add-btn');
    if (!btn) return;
    btn.addEventListener('click', handleAddAll);
    fetchProducts('print', 'picker-print-scroll');
    fetchProducts('mug', 'picker-mug-scroll');
    fetchProducts('tote', 'picker-tote-scroll');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
